import { permissionKeys } from "src/utils/constants";
import { RoleType, UserType } from "src/utils/proptypes"

type PermissionKey = typeof permissionKeys[keyof typeof permissionKeys];

const getUserPermissions = (user: UserType): PermissionKey[] => {
   const allPermissions = user.roles.flatMap(role => (role.permissions ?? []) as string[])
   const uniquePermissions = Array.from(new Set(allPermissions));

   return uniquePermissions;
}

const getRoleByName = (displayName: string, roles: RoleType[]) => {
   return roles.find(role => role.displayName?.trim() === displayName?.trim())
}

const hasPermissions = (required: PermissionKey | { AND?: PermissionKey[], OR?: PermissionKey[] }, permissions: PermissionKey[]): boolean => {
   if (required) {
      if (typeof required === 'string') {
         return permissions.includes(required)
      } else {
         if (required.AND) {
            return required.AND.every(requiredKey => permissions.includes(requiredKey))
         }

         if (required.OR) {
            return required.OR.some(requiredKey => permissions.includes(requiredKey))
         }
      }
   }

   return false;
}

export { getRoleByName, getUserPermissions, hasPermissions }